<div id="edit-personal-details" class="accord bg-offwhite shadow personal-detailsForm">
    <div class="content-edit-area">
        <div class="edit-content">
            <div class="accordion" id="accordionExample">
                <div class="card border-0">
                    <div class="card-header p-0 bg-white border-0" role="tab" id="headingOne">
                        <a #toggleAccordian data-toggle="collapse" data-parent="#accordionEx" href="#collapseOne"
                            aria-expanded="true" aria-controls="collapseOne1">
                            <h5 class="mb-0">
                                <div class="row">
                                    <div class="col-10 sm-14 color-blue mobile16">
                                        Add a biller
                                    </div>
                                    <div class="col-2">
                                        <i class="fas fa-angle-down rotate-icon float-right"></i>
                                    </div>
                                </div>
                            </h5>
                        </a>
                    </div>

                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne"
                        data-parent="#accordionExample">
                        <div class="card-body">
                            <form #billerForm="ngForm" (ngSubmit)="addBiller(billerForm)">
                                <div class="row">
                                    <div class="col-12 mt-2 p-0">
                                        <p class="sm-12 gilroy-bold secondary-text mobile16">About your bill<br />
                                            <span class="sm-10 gilroy-med color-lightgray">
                                                Please note that incorrect details can delay payments.
                                            </span>
                                        </p>
                                        <div class="sm-12 p-0 my-2">
                                            <select name="country_id" (change)="onSelectCountry($event.target.value)" class="input_figma p-3 w-100 bg-white border-0 secondary-text"
                                                required ngModel>
                                                <option value="" selected="selected">Which country is this bill in? </option>
                                                <option *ngFor="let country of countries" value="{{ country.country_id }}">
                                                    {{ country.name }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="sm-12 p-0 my-2">
                                            <select name="biller_category" (change)="onSelectCategory($event.target.value)" class="input_figma p-3 w-100 bg-white border-0 secondary-text"
                                                required>
                                                <option value="" selected="selected">Select a category </option>
                                                <option *ngFor="let category of categoriesName" value="{{ category }}">
                                                    {{ category }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="sm-12 p-0 my-2">
                                            <select name="biller_id" (change) = "onSelectBiller($event.target)" class="input_figma p-3 w-100 bg-white border-0 secondary-text"
                                                required ngModel>
                                                <option value="" selected="selected">Select a billing provider </option>
                                                <option *ngFor="let biller of billersNew" value="{{ biller.biller_id }}" biller-name="{{ biller.biller_name }}">
                                                    {{ biller.biller_name }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="sm-12 p-0 my-2" *ngFor="let input of inputs;let i = index" >
                                            <label for="">{{ input.Name }}</label>
                                            <input type="hidden" name="{{ 'biller_input_name_' + (i+1) }}" [ngModel]="input.Name">
                                            <input type="hidden" name="sku" [ngModel]="input.SKU">
                                            <input type="{{input.Datatype=='Numeric' ? 'number' : 'text'}}" [placeholder]="input.Description" class="input_figma p-3 sm-12 w-100" name="{{ 'biller_input_' + (i+1) }}" [ng-minlength]="input.MinLength" [ng-maxlength]="input.MaxLength" required ngModel>
                                        </div>
                                        <div class="sm-12 p-0 my-2">
                                            <input type="text" placeholder="Nick Name" class="input_figma p-3 sm-12 w-100" name="nick_name" (keydown)="common.checkName($event, false, 30)" required ngModel >
                                        </div>
                                    </div>
                                    <button type="submit" class="btn w-100 primary-btn my-2">Save Changes</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>